import React, { ComponentType } from "react";

import ActivitySuggestion from "@mapmycustomers/shared/types/entity/ActivitySuggestion";

import CadenceSuggestion from "./Suggestions/CadenceSuggestion";
import GapSuggestion from "./Suggestions/GapSuggestion";
import NearBySuggestion from "./Suggestions/NearBySuggestion";
import NoActivitySuggestion from "./Suggestions/NoActivitySuggestion";
import SuggestionProps from "./Suggestions/SuggestionProps";

const typeToComponent: Record<ActivitySuggestion["property"], ComponentType<SuggestionProps>> = {
  cadence: CadenceSuggestion,
  gap: GapSuggestion,
  nearby: NearBySuggestion,
  NoActivity: NoActivitySuggestion,
};

interface Props {
  suggestion: ActivitySuggestion;
}

const Suggestion: React.FC<Props> = ({ suggestion }) => {
  const Component = typeToComponent[suggestion.property];
  return Component ? <Component suggestion={suggestion} /> : null;
};

export default Suggestion;
